module.exports = __webpack_public_path__ + "img/klown.1bb49b4a.svg";